import { resolveSchoolAssets, mergeCardAssetUrls } from './schoolIdCardAssets';
import { getStudentCardQrUrl, getCpRawatLogoUrl } from './studentCardUrl';
import { toApiDateOnly } from './appDateTime';

const addYears = (ds, y) => {
  if (!ds) return null;
  const d = new Date(ds);
  if (Number.isNaN(d.getTime())) return null;
  d.setFullYear(d.getFullYear() + y);
  return toApiDateOnly(d);
};

export function idCardImageCacheKey(school, imageCacheKey = '') {
  if (imageCacheKey) return imageCacheKey;
  const paths = [school?.logo, school?.principal_signature, school?.id_card_footer_bg].filter(Boolean);
  const stamps = paths.map((p) => String(p).match(/_(\d{10,})\./)?.[1]).filter(Boolean);
  return stamps.length ? stamps.sort().pop() : (school?.updated_at ? String(new Date(school.updated_at).getTime()) : '');
}

/** Shared card payload for StudentIdCard + reports downloads. */
export function buildIdCardData(student, school, photoUrl, imageCacheKey = '', assetOverrides = null) {
  const name = [student.first_name, student.last_name].filter(Boolean).join(' ').trim() || 'Student';
  const sid = student.school_id || school?.id;
  const addr = [school?.address, school?.city, school?.state, school?.pincode].filter(Boolean).join(', ');
  const cacheKey = idCardImageCacheKey(school, imageCacheKey);
  const resolved = resolveSchoolAssets(school, sid, cacheKey);
  const merged = assetOverrides
    ? mergeCardAssetUrls(resolved, { ...assetOverrides, photoUrl: assetOverrides.photoUrl || photoUrl })
    : mergeCardAssetUrls(resolved, { photoUrl });
  const affiliation = school?.code ? `CODE: ${String(school.code).toUpperCase()}` : 'SCHOOL ID CARD';

  return {
    schoolName: (school?.name || 'SCHOOL NAME').toUpperCase(),
    slogan: affiliation,
    logoUrl: merged.logoUrl,
    photoUrl: merged.photoUrl || photoUrl,
    initials: (student.first_name?.[0] || '') + (student.last_name?.[0] || '') || '?',
    admissionNo: student.admission_no || '—',
    studentId: student.roll_no || String(student.id || '—'),
    studentName: name,
    fatherName: student.guardian_name || '—',
    classLabel: [student.class_name, student.section_name].filter(Boolean).join(' - ') || '—',
    emergencyPhone: student.guardian_phone || student.phone || '—',
    schoolAddress: addr || school?.name || 'School address',
    joined: student.admission_date,
    expire: addYears(student.admission_date, 1),
    schoolPhone: school?.phone || '—',
    schoolEmail: school?.email || '—',
    schoolWebsite: school?.website || '—',
    principalSignatureUrl: merged.principalSignatureUrl,
    frontBgUrl: '',
    backBgUrl: '',
    footerBgUrl: merged.footerBgUrl,
    managedLogoUrl: getCpRawatLogoUrl(),
    managedOrgName: school?.id_card_managed_org_name || 'CP Rawat Softwares',
    termsText: 'This card is school property. Holder must follow all school rules.',
    termsText2: 'Report loss immediately. Unauthorized use is prohibited.',
    qrPayload: getStudentCardQrUrl(student.id),
  };
}
